import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/components/auth/AuthProvider";
import { SubscriptionLoading } from "./SubscriptionLoading";

interface SubscriptionCheckProps {
  children: React.ReactNode;
}

export function SubscriptionCheck({ children }: SubscriptionCheckProps) {
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
  const { user } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    const checkUserSubscription = async () => {
      try {
        if (!user?.id) {
          setIsCheckingSubscription(false);
          return;
        }

        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('notification_preferences')
          .eq('id', user.id)
          .single();

        if (profileError) {
          throw profileError;
        }

        setIsCheckingSubscription(false);
      } catch (error: any) {
        console.error('Error checking subscription:', error);
        toast({
          title: "Error",
          description: "Could not verify subscription status.",
          variant: "destructive",
        });
        setIsCheckingSubscription(false);
      }
    };

    checkUserSubscription();
  }, [user?.id, toast]);

  if (isCheckingSubscription) {
    return <SubscriptionLoading />;
  }

  return <>{children}</>;
}